import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const GraphIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M23 20.25H21.625V5C21.625 4.6548 21.3447 4.375 21 4.375H16.5C16.1553 4.375 15.875 4.6548 15.875 5V13.375H12.625V11C12.625 10.6548 12.3452 10.375 12 10.375H7.5C7.1548 10.375 6.875 10.6548 6.875 11V16.375H3C2.6548 16.375 2.375 16.6553 2.375 17V20.25H1C0.5859 20.25 0.25 20.5859 0.25 21C0.25 21.4141 0.5859 21.75 1 21.75H23C23.4141 21.75 23.75 21.4141 23.75 21C23.75 20.5859 23.4141 20.25 23 20.25ZM20.375 5.625V20.25H17.125V5.625H20.375ZM15.875 14.625V20.25H12.625V14.625H15.875ZM11.375 11.625V20.25H8.125V11.625H11.375ZM3.625 17.625H6.875V20.25H3.625V17.625Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

GraphIcon.displayName = 'GraphIcon';
